import styled from 'styled-components';

const MessageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

MessageWrapper.displayName = 'MessageWrapper';

export default MessageWrapper;
